import React from "react";
import { AnimateIn, StaggerIn } from "./AnimateIn";
import "./TechAdvantage.css";

const techIcons = [
  // LLM
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>,
  // Agent
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v1a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10H5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z"/><path d="M12 15v7"/></svg>,
  // RAG
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>,
  // Enterprise
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
];

export const TechAdvantage = ({ data }) => {
  if (!data) return null;

  return (
    <section id="technology" className="tech-section">
      <div className="section-container">
        <AnimateIn variant="fadeUp">
          <div className="tech-header">
            <p className="eyebrow">{data.eyebrow}</p>
            <h2 className="section-title">{data.title}</h2>
          </div>
        </AnimateIn>
        <StaggerIn variant="fadeUp" stagger={0.1} className="tech-grid">
          {data.items.map((item, i) => (
            <div key={i} className="tech-card">
              <div className="tech-icon">{techIcons[i]}</div>
              <h3 className="tech-name">{item.title}</h3>
              <p className="tech-desc">{item.description}</p>
            </div>
          ))}
        </StaggerIn>
      </div>
    </section>
  );
};
